import "./App.css";
import React, { createRef } from "react";
import { useScreenshot, createFileName } from "use-react-screenshot";
import Form from "./components/form";

function App() {
  const ref = createRef(null);
  const [image, takeScreenShot] = useScreenshot({
    type: "image/jpeg",
    quality: 1.0,
  });

  const download = (image, { name = "img", extension = "jpg" } = {}) => {
    const a = document.createElement("a");
    a.href = image;
    a.download = createFileName(extension, name);
    a.click();
  };

  const downloadScreenshot = () => takeScreenShot(ref.current).then(download);

  // function fbs_click(TheImg) {
  //   u = TheImg.src;
  //   // t=document.title;
  //   t = TheImg.getAttribute("alt");
  //   window.open(
  //     "http://www.facebook.com/sharer.php?u=" +
  //       encodeURIComponent(u) +
  //       "&t=" +
  //       encodeURIComponent(t),
  //     "sharer",
  //     "toolbar=0,status=0,width=626,height=436"
  //   );
  //   return false;
  // }

  return (
    <div className="App">
      {/* <Header />

      <div style={{ border: "2px solid red" }}>
        <Section />
        <Section2 />
      </div> */}

      {/* <img src={image} alt={"Screenshot"} id="img12" /> */}

      {/* <button style={{ marginBottom: "10px" }} onClick={getImage}>
        Take screenshot
      </button> */}

      {/* <FacebookShareButton url={image}>
        <FacebookIcon size={32} round={true} />
      </FacebookShareButton> */}
      <div>
        <div
          ref={ref}
          style={{
            border: "1px solid #ccc",
          }}
        >
          <Form />
        </div>

        <button
          onClick={downloadScreenshot}
          type="button"
          style={{
            color: "white",
            backgroundColor: "red",
            padding: "8px",
            margin: "10px",
            border: "1px solid red",
            borderRadius: "5px",
            width: "35vw",
          }}
        >
          Download
        </button>
      </div>
    </div>
  );
}

export default App;
